import { useTable, useSortBy, useGlobalFilter, usePagination } from 'react-table';
import { forwardRef, useImperativeHandle, useMemo } from 'react';
import { Table } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import imageNotFound from '../../../assets/icons-image-not-found.png';
import BlankTable from './BlankTable';
import { formatDate, parseDate } from '../../../utils/utility-functions';

const CustomTable = forwardRef(({ tableColumns, tableData, tableRow, icons, workOrder }, ref) => {

    const columns = useMemo(() => tableColumns);
    const data = useMemo(() => tableData);

    const instance = useTable({
        columns,
        data,
        initialState: { pageSize: tableRow }
    },
        useGlobalFilter,
        useSortBy,
        usePagination,
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        pageOptions,
        gotoPage,
        pageCount,
        prepareRow,
        state: { pageIndex, pageSize },
    } = instance;

    const handlePageClick = (data) => {
        gotoPage(data.selected);
    }

    useImperativeHandle(ref, () => instance);

    return (

        <div className='inner-table'>
            <Table {...getTableProps()}>
                {
                    data.length <= 0 ?
                        <BlankTable /> :
                        <thead>
                            {
                                headerGroups.map((headerGroup, index) => (
                                    <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                                        {
                                            headerGroup.headers.map((column, index) => {
                                                return <th {...column.getHeaderProps(column.getSortByToggleProps())} key={index}>
                                                    {column.render('Header')}
                                                    <span>
                                                        {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                                                    </span>
                                                </th>
                                            })
                                        }
                                    </tr>
                                ))
                            }
                        </thead>
                }

                <tbody {...getTableBodyProps()}>
                    {
                        page.map((row, index) => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps()} key={index}>
                                    {
                                        row.cells.map((cell, index) => {
                                            // product listing
                                            if (cell.column.id == 'userApprover') {
                                                return <td key={index}>******</td>
                                            } else if (cell.column.id === 'workOrderId') {
                                                return <td key={index}>{cell.row.original.workOrderId || cell.row.original.enamelPaintingFormId}</td>
                                            } 
                                            else if (cell.column.id === 'image') {
                                                return <td key={index}><img className='table-product-image' src={cell.value && cell.value.startsWith('data:') ? cell.value : imageNotFound} alt="" /></td>
                                            } else if (icons && cell.column.id === 'icons') {
                                                return <td key={index}>
                                                    <div className="table-product-icons">
                                                        {icons.map(icon => (
                                                            <img className={icon.disable && 'table-disable-icons'} src={icon.image} alt="" key={icon.id} onClick={() => !icon.disable ? icon.onClick(row.original.id) : undefined} />
                                                        ))}
                                                    </div>
                                                </td>
                                            } else if (icons && cell.column.id === 'description') {
                                                return <td key={index}>{cell.value.substring(0, 30)}...</td>
                                            } else if (workOrder && cell.column.id === 'date') {
                                                const parsedDate = parseDate(row.original.date)
                                                const formattedDate = formatDate(new Date(parsedDate))
                                                return <td key={index}>{formattedDate}</td>
                                            } else if (workOrder && cell.column.id === 'name') {
                                                return <td key={index}>{row.original.confirmData.name ? row.original.confirmData.name : "********"}</td>
                                            } else {
                                                return <td key={index} {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                            }
                                        })
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </Table >
            <div className='table-pagination'>
                <span>
                    Sayfa {' '}
                    <strong>
                        {pageIndex + 1} / {pageOptions.length}
                    </strong>{' '}
                </span>
                <ReactPaginate
                    previousLabel={'Önceki'}
                    nextLabel={'Sonraki'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={'pagination'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    previousClassName={'page-item'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item'}
                    nextLinkClassName={'page-link'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    activeClassName={'active'}
                />
            </div>
        </div>
    );
});

export default CustomTable;